import React from 'react';
import MainLayoutHome from '../layout/MainLayoutHome';
import Yellow from '../components/Yellow';

const YellowPage = () => {
  return (
    <MainLayoutHome>
        <Yellow/>
    </MainLayoutHome>
  )
}

export default YellowPage